import React from 'react';
export var PageTitle = function (_a) {
    var children = _a.children, firstTitleLine = _a.firstTitleLine, secondTitleLine = _a.secondTitleLine, _b = _a.small, small = _b === void 0 ? false : _b;
    var classes = "page-title" + (small ? ' page-title--small' : '');
    return (React.createElement(React.Fragment, null,
        React.createElement("h1", { className: classes }, firstTitleLine),
        React.createElement("h1", { className: classes + ' page-title--outlined' }, secondTitleLine),
        React.createElement("br", null)));
};
